function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLightning = function SvgIconLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M4.159 22.96c-.12-.065-.161-.189-.095-.29l.477.255a.338.338 0 0 1-.217.075.35.35 0 0 1-.165-.04zM18.734 9 5.29 21.544l5.163-8.963.432-.75H4.73l5.896-9.33h8.488l-5.461 5.653-.819.847h5.899z"
  }));
};
export default SvgIconLightning;